import { render } from "./EmployeeSubunitWidget.vue?vue&type=template&id=1aa2c630&scoped=true"
import script from "./EmployeeSubunitWidget.vue?vue&type=script&lang=js"
export * from "./EmployeeSubunitWidget.vue?vue&type=script&lang=js"

import "./EmployeeSubunitWidget.vue?vue&type=style&index=0&id=1aa2c630&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa2c630"]])

export default __exports__